






















































import Vue, { PropType } from 'vue';
import WidgetWrapper from '@/components/widgets/WidgetWrapper.vue';
import FieldCheckbox from '@/components/form/FieldCheckbox.vue';
import FieldTextArea from '@/components/form/FieldTextArea.vue';
import { BlackWhiteListData } from '@/types/campaign/targets';

export default Vue.extend({
  name: 'TheBlackWhiteList',
  components: { WidgetWrapper, FieldCheckbox, FieldTextArea },
  props: {
    data: {
      type: Object as PropType<BlackWhiteListData>,
      required: true,
    },
  },
  watch: {
    data() {
      this.campaign = this.data;
    },
  },
  methods: {
    changeCampaign(name, value) {
      this.$emit('changeCampaign', name, value);
    },
    changeForm(name, value) {
      this.$emit('changeForm', name, value);
    },
    changeSites(value: number) {
      this.campaign.toggleListSites = value;
    },
  },
  data() {
    return {
      campaign: this.data,
    };
  },
});
